export default __webpack_public_path__ + "static/media/patent05-1.f6d5356e.png";